// Design tokens for PDF templates. Mirrors the AntD theme in App.jsx so
// the on-screen app and the printed resume stay visually coherent.

export const COLORS = {
  // Brand accents
  gold: "#EDC043",
  goldDeep: "#B97A07",
  rust: "#B54708",

  // Text
  navy: "#0F1B23",
  slate: "#475467",
  mute: "#98A2B3",

  // Surfaces & lines
  divider: "#D0D5DD",
  subtleBg: "#FFFAEB",
  white: "#FFFFFF",

  // Blue accents (modern templates)
  blue: "#3B5FE0",
  blueDeep: "#2A4DA3",
  blueSoft: "#2563EB",
  blueMuted: "#3B82F6",
  blueSubtleBg: "#EFF6FF",
  blueBorder: "#BFDBFE",

  // Green/teal accents (Emerald template) — based on #0D6E6E
  green: "#094F4F", // primary brand teal
  greenDeep: "#0D6E6E", // dark header background
  greenSoft: "#0F8080", // medium accent / subtitle text
  greenMuted: "#148A8A", // bullets, chips, link color
  greenSubtleBg: "#F0FAFA", // light section/chip background
  greenBorder: "#A7D4D4", // section heading underline
};

// Type scale (in points — @react-pdf uses pt for sizes by default)
export const TYPE = {
  name: 22,
  headline: 12,
  sectionHeading: 10.5,
  itemTitle: 11,
  body: 10,
  meta: 9.5,
  micro: 9,
};

export const SPACING = {
  pagePadding: {
    paddingTop: 36,
    paddingBottom: 36,
    paddingLeft: 40,
    paddingRight: 40,
  },
  sectionGap: 12,
  itemGap: 8,
  rowGap: 2,
};

// Font families — using PDF built-ins so the POC works offline.
// To use Inter:
//   1. npm i @fontsource/inter
//   2. In fonts.js: Font.register({ family: 'Inter', fonts: [{ src: interTtfUrl, ... }] })
//   3. Replace FONTS.sans below with 'Inter'.
export const FONTS = {
  sans: "Helvetica",
  sansBold: "Helvetica-Bold",
  sansItalic: "Helvetica-Oblique",
  serif: "Times-Roman",
  serifBold: "Times-Bold",
  serifItalic: "Times-Italic",
};
